export default __webpack_public_path__ + "static/media/logo.9be9f538.png";